import apiClient from './api';

/**
 * Menu Service
 * Handles all API calls related to landing page menu
 */
const menuService = {
  /**
   * Get all active menu items
   * @returns {Promise} Promise object with menu data
   */
  getAllMenus: async () => {
    try {
      const response = await apiClient.get('/landingpage-menu');
      return response.data;
    } catch (error) {
      console.error('Error fetching menus:', error);
      throw error;
    }
  },

  /**
   * Get menu by ID
   * @param {number} id - Menu ID
   * @returns {Promise} Promise object with menu data
   */
  getMenuById: async (id) => {
    try {
      const response = await apiClient.get(`/landingpage-menu/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching menu with ID ${id}:`, error);
      throw error;
    }
  },

  /**
   * Get menus by category
   * @param {string} category - Menu category
   * @returns {Promise} Promise object with menu data
   */
  getMenusByCategory: async (category) => {
    try {
      const response = await apiClient.get('/landingpage-menu', {
        params: { kategori: category }
      });
      return response.data;
    } catch (error) {
      console.error(`Error fetching menus by category ${category}:`, error);
      throw error;
    }
  },

  /**
   * Get only active menus
   * @returns {Promise} Promise object with active menu data
   */
  getActiveMenus: async () => {
    try {
      const response = await apiClient.get('/landingpage-menu', {
        params: { status: 'AKTIF' }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching active menus:', error);
      throw error;
    }
  },

  /**
   * Get parent menus only (parent_id = 0)
   * @returns {Promise} Promise object with parent menu data
   */
  getParentMenus: async () => {
    try {
      const response = await apiClient.get('/landingpage-menu/parent/all', {
        params: { status: 'AKTIF' }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching parent menus:', error);
      throw error;
    }
  },

  /**
   * Get submenu by parent ID
   * @param {number} parentId - Parent menu ID
   * @returns {Promise} Promise object with submenu data
   */
  getSubmenuByParentId: async (parentId) => {
    try {
      const response = await apiClient.get(`/landingpage-menu/submenu/${parentId}`, {
        params: { status: 'AKTIF' }
      });
      return response.data;
    } catch (error) {
      console.error(`Error fetching submenu for parent ID ${parentId}:`, error);
      throw error;
    }
  },

  /**
   * Create new menu (if admin functionality needed)
   * @param {Object} menuData - Menu data object
   * @returns {Promise} Promise object with created menu data
   */
  createMenu: async (menuData) => {
    try {
      const response = await apiClient.post('/landingpage-menu', menuData);
      return response.data;
    } catch (error) {
      console.error('Error creating menu:', error);
      throw error;
    }
  },

  /**
   * Update menu (if admin functionality needed)
   * @param {number} id - Menu ID
   * @param {Object} menuData - Menu data object
   * @returns {Promise} Promise object with updated menu data
   */
  updateMenu: async (id, menuData) => {
    try {
      const response = await apiClient.put(`/landingpage-menu/${id}`, menuData);
      return response.data;
    } catch (error) {
      console.error(`Error updating menu with ID ${id}:`, error);
      throw error;
    }
  },

  /**
   * Delete menu (if admin functionality needed)
   * @param {number} id - Menu ID
   * @returns {Promise} Promise object with deletion result
   */
  deleteMenu: async (id) => {
    try {
      const response = await apiClient.delete(`/landingpage-menu/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting menu with ID ${id}:`, error);
      throw error;
    }
  }
};

export default menuService;
